import React, { useState, useEffect, useRef } from "react";
import {
  PageHeader,
  Divider,
  Tag,
  Input,
  Button,
  notification,
  Modal
} from "antd";
import { MainLayout } from "../../layouts/MainLayout";
import { getTags, setTags as _setTags, deleteUi, update } from "../../api/tags";
import ButtonGroup from "antd/lib/button/button-group";

export const AddTags = () => {
  const [tags, setTags] = useState<any>([]);
  const ref = useRef(null);
  const [inp, setInp] = useState<string>("");

  useEffect(() => {
    tgs();
  }, []);

  async function tgs() {
    const _tags: any = await getTags();

    if (_tags.status) {
      console.log(_tags);
      setTags(_tags.data.tags);
    }
  }

  const addTag = async () => {
    if (inp !== "") {
      const done: any = await _setTags(inp.toLowerCase());
      console.log(done);
      if (done.status) {
        tgs();
        notification.success({
          message: "Added new tag"
        });
        setInp("");
      } else {
        notification.error({
          message: "duplicate entry!!"
        });
      }
    }
  };
  return (
    <MainLayout>
      <PageHeader title="Add Tags" />

      <Input
        placeholder="Enter new tag"
        value={inp}
        onChange={e => setInp(e.target.value)}
      />
      <Button type="primary" onClick={addTag}>
        Add Tag
      </Button>
      <Divider />
      {tags.map((tg: any, i: any) => (
        <div
          key={tg.name}
          style={{
            margin: "10px",
            background: "whitesmoke",
            padding: "10px",
            width: "fit-content",
            display: "inline-block",
            borderRadius: "10px",
            border: "1px solid #c5c5c552"
          }}
        >
          <Tag
            style={{
              border: "none"
            }}
          >
            {tg.name}
          </Tag>
          <ButtonGroup>
            <Button
              size="small"
              onClick={async () => {
                await deleteUi(tg.name, "tag");
                tgs();
              }}
              type="ghost"
              icon="delete"
            />
            <Button
              size="small"
              onClick={() => {
                Modal.confirm({
                  icon: null,
                  content: (
                    <div
                      style={{
                        margin: "10px"
                      }}
                    >
                      <Input ref={ref} defaultValue={tg.name} />
                    </div>
                  ),
                  onOk: async () => {
                    await update(tg.name, ref.current.state.value, "tag");
                    tgs();
                  },
                  onCancel: () => {}
                });
              }}
              type="ghost"
              icon="edit"
            />
          </ButtonGroup>
        </div>
      ))}
    </MainLayout>
  );
};
